import {useNavigate, useParams} from "react-router-dom";
import {CaptacionService} from "abastecemento/service";

import {ConexionEntitySummaryPanel} from "conexion/container";
import {conexionElementTypesConstants} from "conexion/model";
import {SectionField} from "base/component/presentational";
import {TextUtil} from "base/utilities";
import {useConcelloAuth} from "concello/auth";

const ViewCaptacionPanel = ({allowConnectionManagement = false}) => {
    const {idCaptacion} = useParams();
    const navigate = useNavigate();
    const {checkAllowed} = useConcelloAuth();

    const handleClickDetail = captacion => {
        navigate(`/concellos/${captacion.concello}/captacions/${captacion.id}/summary`);
    };

    const getSectionData = captacion => {
        return (
            <>
                {captacion.sistema && (
                    <SectionField
                        label="Sistema PMAA:"
                        value={captacion.sistema_label}
                        linkPath={`/concellos/${captacion.concello}/sistemas/${captacion.sistema}/summary`}
                    />
                )}
                <SectionField label="Código:" value={captacion.codigo} />
                <SectionField
                    label="Abastecemento autónomo:"
                    value={TextUtil.formatBoolean(captacion.abastecemento_autonomo)}
                />
                <SectionField label="Titular:" value={captacion.titular_label} />
                <SectionField label="Xestión:" value={captacion.xestion_label} />
                <SectionField label="Estado:" value={captacion.estado_label} />
                <SectionField label="Orixe:" value={captacion.orixe_label} />
                <SectionField label="Tipo:" value={captacion.tipo_label} />
                <SectionField label="Uso:" value={captacion.uso_label} />
            </>
        );
    };

    return (
        <ConexionEntitySummaryPanel
            service={CaptacionService}
            id={idCaptacion}
            title="Resumo de captación"
            getSectionTitle={entity => `Captación: ${entity?.codigo || entity?.id}`}
            getSectionData={getSectionData}
            onClickDetailButton={handleClickDetail}
            showClickDetailButton={entity => checkAllowed(entity.concello)}
            allowConnectionsAsOrigen={allowConnectionManagement}
            allowConnectionsAsDestino={allowConnectionManagement}
            conexionElementType={conexionElementTypesConstants.CAPTACION}
        />
    );
};

export default ViewCaptacionPanel;
